export default async function ({ store, redirect, route, app }) {
  const influencer_id = Number(route.query?.add)

  if (!Number.isNaN(influencer_id)) {
    try {
      const { slug } = await app.$axios.$get(
        `/influencer/influencer/${influencer_id}/slug/`
      )

      return redirect(
        `/band/homepage/?add=${slug}&utm_source=widget_${slug}&widget_id=${influencer_id}`
      )
    } catch (e) {
      return redirect("/")
    }
  } else return redirect("/band/homepage/")
}
